import { render, staticRenderFns } from "./BasicPageNature.vue?vue&type=template&id=3cb5de82&scoped=true&"
import script from "./BasicPageNature.vue?vue&type=script&lang=js&"
export * from "./BasicPageNature.vue?vue&type=script&lang=js&"
import style0 from "./BasicPageNature.vue?vue&type=style&index=0&id=3cb5de82&prod&lang=scss&scoped=true&"
import style1 from "./BasicPageNature.vue?vue&type=style&index=1&id=3cb5de82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb5de82",
  null
  
)

export default component.exports